import type {ForwardedRef} from 'react';
import {useEffect, useRef} from 'react';

export function useForwardedRef<T>(forwardedRef: ForwardedRef<T>) {
  const combinedRef = useRef<T>(null);

  useEffect(() => {
    if (!forwardedRef) {
      return;
    }

    if (typeof forwardedRef === 'function') {
      forwardedRef(combinedRef.current);
    } else {
      forwardedRef.current = combinedRef.current;
    }
  }, [forwardedRef]);

  return combinedRef;
}
